<template>
	<div class="main-contents">
        <!-- KCP 본인확인 V2 인증창 호출 폼 -->
        <!-- 거래등록 응답으로 받은 call_url 로 reg_cert_key 를 전송하여 본인확인 창을 호출한다. -->
        <form name="form_auth" method="post" :action="input.call_url">
            <!-- 거래등록키 (필수) -->
            <input type="hidden" name="reg_cert_key" :value="input.reg_cert_key"/>
            <!-- 인증창 호출 방식 : N = 팝업 방식 / Y = 페이지전환 방식(모바일) -->
            <input type="hidden" name="kcp_page_submit_yn" value="N"/>
        </form>
	</div>
</template>

<script>
export default {
	data() {
		return {
			input : {
				call_url : '',
				reg_cert_key : '',
			}
		}
	},
	mounted() {
		this.getKcpcertConfig();
	},

	methods: {
		// 1. 본인확인 거래등록 → call_url, reg_cert_key 수신
		getKcpcertConfig() {
			this.$.httpPost('/api/mem/kcpcert/getKcpcertConfig', {})
				.then(res => {
					// 거래등록 실패
					if (res.data.res_cd !== '0000') {
						alert('본인확인 거래등록에 실패했습니다.' + (res.data.res_msg ? '\n' + res.data.res_msg : ''));
						window.close();
						return;
					}

					this.input.call_url     = res.data.call_url;
					this.input.reg_cert_key = res.data.reg_cert_key;

					// 인증창 호출
					setTimeout(this.formSubmit, 1);
				})
				.catch(err => {
					var msg = (err.response && err.response.data && err.response.data.error_description)
						? err.response.data.error_description
						: '본인확인 요청 중 오류가 발생했습니다.';
					alert(msg);
					window.close();
				});
		},

		formSubmit() {
			document.form_auth.submit();
		},
	},
}
</script>
